import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import Loader from '../../../../Global/Spinner'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { GET_AVERAGE_TIME_BY_STATUS_ID } from '../../../../../graphql/Catalog/ReportsQueries/reportsQueries'

const GetAverageTimeByStatusIdItem = ({
  startStatus,
  endStatus,
  filters,
  setExistResult,
}) => {
  //STATES:
  const [dataResp, setDataResp] = useState([])

  //QUERIES:
  const { loading, error, data } = useQuery(GET_AVERAGE_TIME_BY_STATUS_ID, {
    variables: {
      startStatusId: startStatus.id,
      endStatusId: endStatus.id,
      filters: { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
    },
    fetchPolicy: 'cache-and-network',
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      setDataResp(data?.result)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  useEffect(() => {
    if (dataResp && !dataResp?.day && !dataResp?.time) {
      setExistResult(false)
    } else {
      setExistResult(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataResp])

  if (loading) return <Loader size="2rem" />

  if (dataResp && !dataResp?.day && !dataResp?.time) return <></>

  return (
    <div className="border border-1 mr-3 mb-3" style={{ borderRadius: 5 }}>
      <div
        className="bg-gray-light p-2 text-uppercase text-bold"
        style={{ fontSize: 13 }}
      >
        De <StatusSpan dataStatus={startStatus} /> a {` `}
        <StatusSpan dataStatus={endStatus} />
      </div>
      <div className="p-2">
        {dataResp?.day && <h4 className="text-bold">{dataResp.day}</h4>}
        {dataResp?.time && <h4 className="text-bold">{dataResp.time}</h4>}
      </div>
    </div>
  )
}

const StatusSpan = ({ dataStatus }) => {
  return (
    <span className={`px-1 rounded customBgTransp-${dataStatus.classColorTxt}`}>
      {dataStatus.labelMain}
    </span>
  )
}

export default GetAverageTimeByStatusIdItem
